import { useState, useEffect, useCallback } from "react";
import { productService } from "../Service/AllSalestoolAPI";

const productsCache = {};

export const preloadAllProducts = async () => {
  const countries = ["India", "Portugal", "Dubai", "Canada"];
  for (const countryName of countries) {
    if (!productsCache[countryName]) {
      try {
        const response = await productService.getProductsByCountry(countryName);
        if (Array.isArray(response)) {
          response.forEach((item) => {
            if (item.productImage) {
              const img = new Image();
              let src = item.productImage;
              if (
                !src.startsWith("http") &&
                !src.startsWith("data:") &&
                !src.startsWith("/static")
              ) {
                src = `data:image/png;base64,${src}`;
              }
              img.src = src;
            }
          });
        }
        productsCache[countryName] = response;
      } catch (err) {
        // Ignore preload errors
      }
    }
  }
};

export const useProductsByCountry = (countryName) => {
  const [data, setData] = useState(productsCache[countryName] || null);
  const [loading, setLoading] = useState(!productsCache[countryName] && !!countryName);
  const [error, setError] = useState(null);

  const fetchProducts = useCallback(async () => {
    if (!countryName) return;

    if (productsCache[countryName]) {
      setData(productsCache[countryName]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await productService.getProductsByCountry(countryName);
      productsCache[countryName] = response;
      setData(response);
    } catch (err) {
      setError(err.message || "Failed to fetch products");
    } finally {
      setLoading(false);
    }
  }, [countryName]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  return { data, loading, error, refetch: fetchProducts };
};

